import { useDispatch } from 'react-redux';
import { FlexContainer, Text, Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { hideModalAction } from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import { CloseIcon } from 'Components/icons';
import GratitudeIcon from 'Components/icons/GratitudeIcon';
import { removeOverflow } from 'Styles/utils/utils';
import { routes } from 'Constants/routes';
import * as Styled from './styles';

const GratitudeModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation(locizeNS.MODALS);

  const closeModal = (): void => {
    removeOverflow();
    dispatch(hideModalAction());
    history.push(routes.DASHBOARD);
  };

  return (
    <Styled.ModalContainer>
      <Styled.ModalContent>
        <Styled.CloseButton onClick={closeModal}>
          <CloseIcon />
        </Styled.CloseButton>
        <FlexContainer align="center" direction="column">
          <GratitudeIcon />
          <Text tag="h3" type="fds_text_bold_L">
            {t('Gratitude.title')}
          </Text>
          <Text type="fds_text_medium_S" align="center" mt="fds_size_08" mb="fds_size_40">
            {t('Gratitude.subtitle')}
          </Text>
          <Buttons.Classic onClick={closeModal} size="s" mode="success" label={t('Modal.close')} />
        </FlexContainer>
      </Styled.ModalContent>
    </Styled.ModalContainer>
  );
};

export default GratitudeModal;
